import { render, staticRenderFns } from "./GestionRetiros.vue?vue&type=template&id=52272a78&"
import script from "./GestionRetiros.vue?vue&type=script&lang=js&"
export * from "./GestionRetiros.vue?vue&type=script&lang=js&"
import style0 from "./GestionRetiros.vue?vue&type=style&index=0&id=52272a78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports